import { configureStore } from "@reduxjs/toolkit";

import chatSlice from "./slices/ChatSlice/chatSlice";
import formSlice from "./slices/FormSlice/formSlice";

const store = configureStore({
  reducer: {
    chat: chatSlice,
    form: formSlice,
  },
});

export default store;
